import * as Styled from './image.styles';
import type { ImageProps } from './image.types';

export const Image = ({ className, ...props }: ImageProps): JSX.Element => (
  <Styled.Image className={className} data-xds="Image" {...props} />
);

Image.displayName = 'Image';
